import React, { PureComponent } from 'react';
import ImporteSinIva from './ImporteSinIva';

class ImporteTotal extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {importeSinIva, importeConIva, motivoAjusteDataFiltrado, ajusteEdicion, motivoAjusteEdicion } = this.props.importes;
        let result = 0, importeParaMostrar;
        let importePesos;
        let importeDolares;
        result = motivoAjusteDataFiltrado && motivoAjusteDataFiltrado.PermiteIva && motivoAjusteDataFiltrado.MontoIva && importeSinIva != "" 
        ? parseFloat(importeSinIva) + (parseFloat(importeSinIva) * parseFloat(motivoAjusteDataFiltrado.MontoIva/100))  : importeSinIva;

        if (isNaN(result) || result == "")
            importeParaMostrar = "";
        else
            {
                result < 0 ? result = result * -1 : result = result;
                importeParaMostrar = parseFloat(result).toFixed(2);
            }

        result = "$ " + importeParaMostrar;


        if (motivoAjusteDataFiltrado && motivoAjusteDataFiltrado.TipoMovimiento) {

            let calculo = motivoAjusteEdicion[0].PermiteIva ? parseFloat(importeSinIva) + (parseFloat(importeSinIva) * parseFloat(motivoAjusteEdicion[0].MontoIva/100))  : importeSinIva;

            if (importeSinIva < 0 ) {
                calculo = calculo * -1
            }

            result = "$ " + calculo;
        }
        return (
            <div className="row top-separator-xs">
                <label className="label-primary contenedorLabelImporteTotal" >Importe Total *</label>
                <label className="contenedorMontoImporteTotal">{result}</label>
            </div>
        )
    }
}

export default ImporteTotal;